import React, { Component } from "react"
import VaccinationForm from "forms/Vaccination_Form"

class NewEntry extends Component {
  render() {
    return (
      <div className="columns is-mobile is-centered">
        <div className="column is-5-desktop is-full-mobile is-6-tablet">
          <VaccinationForm valuesToEdit={{}} {...this.props} />
        </div>
      </div>
    )
  }
}

export default NewEntry
